import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fonts } from '../../consts/fonts';
import { ShopInfomation } from '../../types/shop';

export const shopSlice = createSlice({
    name: 'theme',
    initialState: ({
        theme: {
            primaryColor: '#eeeeee',
            secondaryColor: '#f50057',
        },
        name: "",
        id: "",
        font: {
            fontUrl: "",
            fontFamily: "Arial, sans-serif"
        },
    } as ShopInfomation),
    reducers: {
        setShop: (state: any, action: PayloadAction<ShopInfomation>) => {
            const shopData = action.payload;
            state.theme = shopData.theme;
            state.name = shopData.name;
            state.id = shopData.id;
            state.font = shopData.font;
        },
        setShopId: (state: any, action: PayloadAction<string>) => {
            if (state.id !== '') return;
            state.id = action.payload;
        },
        setPrimaryColor: (state: any, action: PayloadAction<string>) => {
            state.theme.primaryColor = action.payload;
        },
        setSecondaryColor: (state: any, action: PayloadAction<string>) => {
            state.theme.secondaryColor = action.payload;
        },
        setShopName: (state: any, action: PayloadAction<string>) => {
            state.name = action.payload;
        },
        setFont: (state: any, action: PayloadAction<string>) => {
            for (let font of fonts) {
                if (font.fontFamily === action.payload) {
                    state.font = font;
                    return;
                }
            }
        }
    },
});

export const { setShop, setShopId, setPrimaryColor, setSecondaryColor, setShopName, setFont } = shopSlice.actions;

export default shopSlice.reducer;